import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@20.17.30_db0@0.3.1_eslint@9.24.0_jiti@2.4.2__io_ocpep4f6fueeb25brfouasn6ne/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}